import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { formatNumber } from "../Utils/FormatNumbers";

const getadditionalTooltipContent = (data, tooltipKeys) => {
  if (tooltipKeys.length === 0) return null;
  console.log(tooltipKeys);
  //   if (!data || !Array.isArray(tooltipKeys) || tooltipKeys.length === 0) {
  //     return null;
  //   }

  return (
    <ul>
      {tooltipKeys.map(({ responseKey, caption, numberFormat }, index) => {
        console.log(responseKey);

        const value = Number(data[responseKey]);
        const formattedValue = formatNumber(value, numberFormat);

        return (
          <li key={index}>
            <p className="font-[400] text-gray-500">
              {`${caption} : ${formattedValue}`}
            </p>
          </li>
        );
      })}
    </ul>
  );
};

const renderDataKey = (
  key,
  index,
  data,
  COLORS,
  currentLineIndex,
  valueKeys
) => {
  console.log(key);
  const value = data[key];

  console.log(value);
  console.log(valueKeys);

  // const datakey = key.split('|');

  const datakey = typeof key === "string" ? key.split("|") : [];
  console.log(datakey);

  const requiredIndex = valueKeys?.findIndex(
    (obj) => obj.responseKey === datakey[datakey.length - 1]
  );
  console.log(datakey);

  // const { numberFormat: SufixPrefix } = valueKeys[requiredIndex] || {};

  const SufixPrefix =
    requiredIndex !== -1 && requiredIndex != null
      ? valueKeys[requiredIndex]?.numberFormat
      : null;
  console.log(SufixPrefix);
  console.log(valueKeys);

  console.log(valueKeys);
  console.log(requiredIndex);
  console.log(datakey);

  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;

  const isBold =
    index === currentLineIndex
      ? "font-bold text-gray-900"
      : "font-normal text-gray-500";
  const shapeColor = COLORS[index];

  return (
    <div key={key} className="mb-1 flex items-center">
      <span
        className="w-3 h-3 rounded-full mr-2"
        style={{ backgroundColor: shapeColor }}
      />

      <p className={`font-[400] text-gray-500 ${isBold}`}>
        {`${key} : ${formattedValue}`}
      </p>
    </div>
  );
};

const renderDataKeyWithPercentage = (
  key,
  index,
  data,
  COLORS,
  currentLineIndex,
  valueKeys,
  totalKey
) => {
  const value = data[key];
  console.log(valueKeys);
  const datakey = key.split("|");
  const valueKeysArray = Object.values(valueKeys);
  console.log(valueKeysArray);
  const requiredIndex = valueKeysArray.findIndex(
    (obj) => obj.responseKey === datakey[datakey.length - 1]
  );
  const { numberFormat: SufixPrefix } = valueKeys[requiredIndex] || {};
  const totalValue = data[totalKey];
  console.log(totalValue, totalKey);
  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;

  const isBold =
    index === currentLineIndex
      ? "font-bold text-gray-900"
      : "font-normal text-gray-500";
  const shapeColor = COLORS[index];

  return (
    <div key={key} className="mb-1 flex items-center">
      <span
        className="w-3 h-3 rounded-full mr-2"
        style={{ backgroundColor: shapeColor }}
      />

      <p className={`font-[400] text-gray-500 ${isBold}`}>
        {`${key} : ${formattedValue} (${((value / totalValue) * 100).toFixed(
          1
        )}%)`}
      </p>
    </div>
  );
};

//without color renderDataKey
const renderDataKeyWithOutColor = (key, data, valueKeys = []) => {
  console.log(valueKeys);
  console.log(data);

  // const requiredIndex = valueKeys.findIndex(obj => obj.responseKey === key);
  const requiredIndex = valueKeys.findIndex((obj) => obj.responseKey === key);
  const value = data[key] || "null";

  console.log(value);
  console.log(requiredIndex);

  console.log(key);
  console.log(valueKeys);
  const { numberFormat: SufixPrefix } = valueKeys[requiredIndex] || {};
  console.log(SufixPrefix);
  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;
  return (
    <div key={key} className="mb-1 flex items-center">
      <p className={`font-[400] text-gray-500 `}>
        {`${key} : ${formattedValue} `}
      </p>
    </div>
  );
};

const renderDataKeyTree = (
  key,
  index,
  data,
  COLORS,
  currentLineIndex,
  valueKeys,
  rowkey
) => {
  console.log(key);
  const value = data[key];
  console.log(rowkey);
  const rowValue = data[rowkey];
  console.log(rowValue);

  console.log(value);
  console.log(valueKeys);

  // const datakey = key.split('|');

  const datakey = typeof key === "string" ? key.split("|") : [];
  console.log(datakey);

  const requiredIndex = valueKeys?.findIndex(
    (obj) => obj.responseKey === datakey[datakey.length - 1]
  );
  console.log(datakey);

  // const { numberFormat: SufixPrefix } = valueKeys[requiredIndex] || {};

  const SufixPrefix =
    requiredIndex !== -1 && requiredIndex != null
      ? valueKeys[requiredIndex]?.numberFormat
      : null;
  console.log(SufixPrefix);
  console.log(valueKeys);

  console.log(valueKeys);
  console.log(requiredIndex);
  console.log(datakey);

  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;

  const isBold =
    index === currentLineIndex
      ? "font-bold text-gray-900"
      : "font-normal text-gray-500";
  const shapeColor = COLORS[index];

  return (
    <div key={key} className="mb-1 flex items-center">
      <span
        className="w-3 h-3 rounded-full mr-2"
        style={{ backgroundColor: shapeColor }}
      />

      <p className={`font-[400] text-gray-500 ${isBold}`}>
        {`${key} : ${formattedValue}`}
      </p>
    </div>
  );
};

const CustomTooltip = (props) => {
  const {
    chartType,
    active,
    payload,
    SufixPrefix,
    colorSchemeid,
    total,
    currentLineIndex,
    rowKeys = [],
    valueKeys = [],
    headerKeys = [],
    tooltipKeys = [],
    columnKeys = [],
    toolTipArray,
    colorMapping,
  } = props;
  if (!active || !payload || !payload.length) {
    return null;
  }

  console.log(tooltipKeys);

  const data =
    chartType === "pie" ? payload[0]?.payload?.payload : payload[0]?.payload;
  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors || ["#007a87"];
  console.log(data);

  let heading = null;
  let content = null;
  let additionalTooltipContent = null;
  const rowKey = rowKeys[0]?.responseKey;
  console.log(rowKey);

  console.log(additionalTooltipContent);

  switch (chartType) {
    case "pie": {
      //heading

      const headingValue = data[rowKey];
      heading = <span className="font-bold">{headingValue}</span>;

      //content
      const valueKeyCaption = valueKeys[0]?.caption;
      const valueResponseKey = valueKeys[0]?.responseKey;
      const value = data[valueResponseKey];
      console.log(valueKeyCaption);
      console.log(valueResponseKey);
      console.log(value);

      content = (
        <p className="font-[400] text-gray-500">
          {`${valueKeyCaption} : ${formatNumber(value, SufixPrefix)} (${(
            (value / total) *
            100
          ).toFixed(1)}%)`}
        </p>
      );

      //tooltip
      // additionalTooltipContent = getadditionalTooltipContent(data, tooltipKeys);

      additionalTooltipContent = getadditionalTooltipContent(data, tooltipKeys);

      console.log(toolTipArray);

      break;
    }
    case "line": {
      const headingKey = columnKeys[0]?.responseKey;
      console.log(headingKey);
      const headingValue = data[headingKey];
      heading = <span className="font-bold">{headingValue}</span>;
      console.log(headingValue);
      content = (
        <div>
          {headerKeys.map((item, index) =>
            renderDataKey(
              item,
              index,
              data,
              COLORS,
              currentLineIndex,
              valueKeys
            )
          )}
        </div>
      );
      console.log(data);

      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            renderDataKey(
              item,
              index,
              data,
              COLORS,
              currentLineIndex,
              toolTipArray,
              valueKeys
            )
          )}
        </div>
      );
      console.log(valueKeys);
      console.log(toolTipArray);

      console.log(tooltipKeys);

      break;
    }
    case "bar": {
      const headingKey = columnKeys[0]?.responseKey;
      const headingValue = data[headingKey];
      console.log(headingValue);

      heading = <span className="font-bold">{headingValue}</span>;

      console.log(currentLineIndex);
      console.log(headerKeys);
      console.log(data);

      console.log(rowKeys);

      console.log(data);

      rowKeys.length > 0
        ? (content = (
            <div>
              {headerKeys.map((item, index) => {
                console.log(item);
                const arrayOfString = item.split("|");
                const totalKey = `Total ${
                  arrayOfString[arrayOfString.length - 1]
                }`;
              return renderDataKeyWithPercentage(
                item,
                index,
                data,
                COLORS,
                currentLineIndex,
                valueKeys,
                totalKey,
                colorMapping
              );
            })}
          </div>
        ))
        : (content = (
          <div>
            {headerKeys.map((item, index) =>
              renderDataKey(
                item,
                index,
                data,
                COLORS,
                currentLineIndex,
                valueKeys,
                colorMapping
              )
            )}
          </div>
        ));

      console.log(tooltipKeys);

      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            rowKeys.length > 0
              ? renderDataKey(
                item,
                index,
                data,
                COLORS,
                currentLineIndex,
                toolTipArray,
                valueKeys, colorMapping
              )
              : renderDataKeyWithOutColor(item, data, toolTipArray)
          )}
        </div>
      );
      console.log(toolTipArray);

      console.log(tooltipKeys);

      break;
    }
    case "areachart": {
      const headingKey = columnKeys[0]?.responseKey;

      const headingValue = data[headingKey];
      heading = <span className="font-bold">{headingValue}</span>;
      console.log(headerKeys);
      console.log(valueKeys[0]);

      rowKeys.length > 0
        ? (content = (
            <div>
              {headerKeys.map((item, index) => {
                console.log(rowKeys);
                const arrayOfString = item.split("|");
                console.log(arrayOfString);

                const totalKey = `Total ${
                  arrayOfString[arrayOfString.length - 1]
                }`;
                console.log(totalKey);

              console.log(item);
              return renderDataKeyWithPercentage(
                item,
                index,
                data,
                COLORS,
                currentLineIndex,
                valueKeys,
                totalKey,
                colorMapping
              );
            })}
          </div>
        ))
        : (content = (
          <div>
            {headerKeys.map((item, index) =>
              renderDataKey(
                item,
                index,
                data,
                COLORS,
                currentLineIndex,
                valueKeys,
                colorMapping
              )
            )}
          </div>
        ));
      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            renderDataKey(
              item,
              index,
              data,
              COLORS,
              currentLineIndex,
              toolTipArray,
              valueKeys, colorMapping
            )
          )}
        </div>
      );
      console.log(toolTipArray);

      console.log(tooltipKeys);
      break;
    }
    case "scatter": {
      const headingKey = columnKeys[0]?.responseKey;
      console.log(headingKey);
      //color
      let color = COLORS[0];
      console.log(color);

      if (rowKey && headerKeys.length > 0) {
        console.log(rowKey);
        console.log(headerKeys);
        const categoryValue = data[rowKey];
        const headerIndex = headerKeys.indexOf(categoryValue);
        console.log(headerIndex);
        color = COLORS[headerIndex];
        console.log(color);

      }
      const headingValue = data[headingKey];
      console.log(headingValue);
      heading = (
        <div className="flex items-center justify-start">
          <span
            className="w-3 h-3 rounded-full mr-2"
            style={{ backgroundColor: color }}
          />
          <span className="font-bold ">{headingValue}</span>
        </div>
      );

      //key
      const valueXasixKey = valueKeys[0]?.responseKey;
      const valueYasixKey = valueKeys[1]?.responseKey;

      // create  array
      const axisKeysArray = [rowKey, valueXasixKey, valueYasixKey];

      const filteredAxisKeysArray = axisKeysArray.filter(
        (key) => key !== null && key !== undefined
      );
      console.log(SufixPrefix);

      content = (
        <div>
          {filteredAxisKeysArray.map((item, index) =>
            renderDataKeyWithOutColor(item, data, valueKeys)
          )}
        </div>
      );
      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            renderDataKeyWithOutColor(
              item.responseKey,
              data,
              tooltipKeys,
              valueKeys
            )
          )}
        </div>
      );

      // console.log(tooltipKeys);
      break;
    }
    case "radar": {
      const headingKey = columnKeys[0]?.responseKey;
      const headingValue = data[headingKey];
      heading = <span className="font-bold ">{headingValue}</span>;

      const valueResponseKey = valueKeys[0]?.responseKey;
      console.log(valueResponseKey);

      content = renderDataKeyWithOutColor(valueResponseKey, data, valueKeys);

      console.log(tooltipKeys);
      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            renderDataKeyWithOutColor(item.responseKey, data, tooltipKeys)
          )}
        </div>
      );
      console.log(tooltipKeys);
      break;
    }

    case "tree":
      {
        const headingKey = columnKeys[0]?.responseKey;
        let headingValue = headingKey ? data.root?.[headingKey] : undefined;
        // console.log(valueKeys);
        // console.log(columnKeys);
        // console.log(headingValue);
        console.log(payload);

        if (headingValue === undefined) {
          headingValue = data[headingKey];
        }

        console.log(data);
        console.log(tooltipKeys);

        const rowKey = rowKeys[0]?.responseKey;
        const valueXasixKey = valueKeys[0]?.responseKey;

        heading = <span className="font-bold ">{headingValue}</span>;
        //key Array
        const contentKeyArray = [rowKey, valueXasixKey];
        console.log(rowKey);
        console.log(valueXasixKey);

        const filteredAxisKeysArray = contentKeyArray.filter(
          (key) => key !== null && key !== undefined
        );

        content = (
          <div>
            {filteredAxisKeysArray.map((item, index) =>
              renderDataKeyWithOutColor(
                item,

                data,

                valueKeys
              )
            )}
          </div>
        );
        additionalTooltipContent = (
          <div>
            {tooltipKeys.map((item, index) =>
              renderDataKeyWithOutColor(
                item.responseKey,
                data,
                tooltipKeys,

                valueKeys
              )
            )}
          </div>
        );
        console.log(tooltipKeys);
        console.log(data);
        console.log(valueKeys[0]);
      }
      break;
    case "combochart":
      {
        const headingKey = columnKeys[0]?.responseKey;
        const headingValue = data[headingKey];
        console.log(headingKey);
        console.log(headingValue);
        console.log(SufixPrefix);
        heading = <span className="font-bold ">{headingValue}</span>;

        content = (
          <div>
            {valueKeys.map((item, index) => {
              console.log(item);
              console.log(valueKeys);
              return renderDataKey(
                item.responseKey,
                index,
                data,
                COLORS,
                currentLineIndex,
                valueKeys, colorMapping
              );
            })}
          </div>
        );
        console.log(tooltipKeys);

        additionalTooltipContent = (
          <div>
            {tooltipKeys.map((item, index) =>
              renderDataKey(
                item.responseKey,
                index,
                data,
                COLORS,
                currentLineIndex,
                tooltipKeys,
                valueKeys, colorMapping
              )
            )}
          </div>
        );

        console.log(tooltipKeys);
        console.log(valueKeys);
        console.log(data);
        console.log(currentLineIndex);
      }
      break;
    default:
      const headingKey = columnKeys[0]?.responseKey;
      console.log(headerKeys);
      heading = data[headingKey];
      content = null;
  }

  return (
    <div
      className="border border-gray-200 rounded bg-white p-[10px]"
      style={{
        background: "rgba(255, 255, 255, 0.9)",
        padding: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="w-auto flex flex-col items-start justify-start text-gray-700  mb-1">
        {heading}
        {content}
        {additionalTooltipContent}
      </div>

      {/* {SufixPrefix && (
        <div className="w-auto flex flex-col items-start justify-start text-gray-700  mb-1">

          {heading}
          {content}
          {additionalTooltipContent}
        </div>
      )} */}
    </div>
  );
};

export { CustomTooltip };
